<template>
    <div :class="groupClass">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            group: {type: String, required: true},
        },

        computed: {
            groupClass: function () {
                return 'shc-group-' + this.group;
            }
        },

        mounted: function () {
            $('.' + this.groupClass)
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/SharedHeightContainer.vue